import { pick } from 'lodash-es';

import {
  TOGGLE_QUICKVIEW,
  APP_QUICKVIEW_REQUEST,
  APP_QUICKVIEW_SUCCESS,
  APP_QUICKVIEW_FAILURE,
  DETAILS_APP_QUICKVIEW_REQUEST,
  DETAILS_APP_QUICKVIEW_SUCCESS,
  DETAILS_APP_QUICKVIEW_FAILURE,
  CANCEL_REQUEST,
} from './action-types';
import { ASSET } from '../configs/constants';
import api, { makeAppAssetList } from '../api';
import { isUnified, unifiedRefNoBy } from '../../../utils/helpers';

const { app_details } = ASSET;

const { getCancelToken, cleanup } = api.buildRequestCancelation();

export const cleanupAppRequests = cleanup;

const fetchAppQuickview = () => (dispatch, getState) => {
  const { activeEntity, permissions } = getState();
  const filters = pick(activeEntity, ['ref_no', 'store']);
  const cancelToken = getCancelToken('appAssetRequest').token;

  makeAppAssetList(permissions).forEach((asset) => {
    dispatch({
      type: APP_QUICKVIEW_REQUEST,
      asset,
    });

    api
      .fetchAppQuickview({ filters, asset }, { cancelToken })
      .then(({ data: { assets } }) => {
        dispatch({
          type: APP_QUICKVIEW_SUCCESS,
          data: {
            [activeEntity.uniqKey]: {
              ...assets,
            },
          },
          asset,
        });
      })
      .catch((error) => {
        if (api.isCancel(error)) {
          dispatch({
            type: CANCEL_REQUEST,
            uniqKey: activeEntity.uniqKey,
          });
        } else {
          dispatch({
            type: APP_QUICKVIEW_FAILURE,
            asset,
          });
        }
      });
  });
};

export const fetchAppQuickviewByAsset =
  (assetsList, filtersByAsset = {}) =>
  (dispatch, getState) => {
    const { activeEntity } = getState();
    const filters = pick(activeEntity, ['ref_no', 'store']);

    assetsList.forEach((asset) => {
      dispatch({
        type: APP_QUICKVIEW_REQUEST,
        asset,
      });
      api
        .fetchAppQuickview(
          { filters: { ...filters, ...filtersByAsset[asset] }, asset },
          { cancelToken: getCancelToken(asset).token }
        )
        .then(({ data: { assets } }) => {
          dispatch({
            type: APP_QUICKVIEW_SUCCESS,
            data: {
              [activeEntity.uniqKey]: assets,
            },
            byAssetFetch: true,
            asset,
          });
        })
        .catch((error) => {
          if (!api.isCancel(error)) {
            dispatch({
              type: APP_QUICKVIEW_FAILURE,
              asset,
            });
          }
        });
    });
  };

export const openAppQuickView = (app) => (dispatch, getState) => {
  const { activeEntity, data } = getState();

  const kind = isUnified(app.store) ? 'unified_app' : 'app';
  const uniqKey = unifiedRefNoBy({ ref_no: app.ref_no, store: app.store, kind });

  // Prevent opening if already open
  if (activeEntity && activeEntity.ref_no === app.ref_no) return;

  dispatch({
    type: TOGGLE_QUICKVIEW,
    isOpen: true,
    activeEntity: { ...app, kind, uniqKey },
  });

  if (!data?.[uniqKey]) {
    dispatch(fetchAppQuickview());
  }
};

// App Details
const fetchAppQuickviewDetails = (detailsStore) => (dispatch, getState) => {
  dispatch({ type: DETAILS_APP_QUICKVIEW_REQUEST });

  const { activeEntity } = getState();
  const params = pick(activeEntity, ['ref_no', 'store']);

  api
    .fetchAppQuickviewDetails(
      { ...params, detailsStore },
      getCancelToken('appDetailsRequest').token
    )
    .then(({ data: { assets } }) => {
      dispatch({
        type: DETAILS_APP_QUICKVIEW_SUCCESS,
        data: {
          [activeEntity.uniqKey]: {
            [app_details]: {
              [detailsStore]: assets[app_details],
            },
          },
        },
      });
    })
    .catch((error) => {
      if (!api.isCancel(error)) {
        dispatch({
          type: DETAILS_APP_QUICKVIEW_FAILURE,
        });
      }
    });
};

export const requestAppQuickViewDetails = (detailsStore) => (dispatch, getState) => {
  const { activeEntity, data } = getState();

  if (!data?.[activeEntity.uniqKey]?.[app_details]?.[detailsStore]) {
    dispatch(fetchAppQuickviewDetails(detailsStore));
  }
};
